import db from "../../js/db";
import * as types from "../mutations-types";

const state = {
  my: {},
};

const getters = {
  cuori: (state) => state.my || {},
  cuoriCalciatore: (state) => (calciatoreId) => {
    return state.my && state.my[calciatoreId] ? parseInt(state.my[calciatoreId]) : 0;
  },
};

const actions = {
  fetchMyCuori() {
    db.fetchMyCuori();
  },
  setCuoriCalciatore({}, { calciatoreId, cuori }) {
    return db.setCuoriCalciatore(calciatoreId, cuori);
  },
};

const mutations = {
  [types.CUORI_SET](state, cuori) {
    state.my = cuori || {};
  },
  [types.CUORI_CLR](state) {
    state.my = {};
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
